import { render, staticRenderFns } from "./SupervisorFeedbackPanel.vue?vue&type=template&id=847a1fb6&scoped=true&"
import script from "./SupervisorFeedbackPanel.vue?vue&type=script&lang=js&"
export * from "./SupervisorFeedbackPanel.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorFeedbackPanel.vue?vue&type=style&index=0&id=847a1fb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847a1fb6",
  null
  
)

export default component.exports